import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import { 
    IsXsDownScreen
} from '../../../business-components/Service/GlobalService'

import {
    GridContainer,
    GridItem1,
    GridItem2,
    GridItem3,
    GridItem3xs10,
    GridItem4,
    GridItem4xs5,
    GridItem4xs8,
    GridItem5xs1,
    GridItem6xs10,
    GridItem10,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridEntradaDados,
    CardGridDivHeaderEntradaDados,
    CardGridDividerElementos,
    CardGridDivBodyEntradaDados,
} from '../../../business-components/Card/Card'

import {
    TextFieldNumberSelectDestaque,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    TipoProjetoVidaSonho,
    IconButtonClearEntradaDadosProjetoVidaSonho,
    Valor,
    ValorAcumulacaoJaRealizado,
    IdadeRealizacao,
    AnoRealizacao,
    HelpValorAcumulacaoJaRealizado,
    TracarMeta,
    HelpTracarMeta,
    MesAnoInicioAcumulacao,
    MesAnoFimAcumulacao,
    MesRealizacao,
    DadosInvalidosTracarMeta,
    TipoPeriodicidadeAporte,
    Recorrencia,
    AnoLimiteRecorrencia,
    ControlarAportes,
    DiaAporte,
    Descricao,
    HelpDescricaoProjetoVidaSonho,
    Observacao,
} from './ProjetoVidaSonhoCompProjetoVidaSonho'



const ProjetoVidaSonhoFormProjetoVidaSonhoItem = ({ values, handleChange, setFieldValue, arrayHelpers, linhaTipoLicenca, item, ind, simplificado }) => {
    
    const isXsDownScreen = IsXsDownScreen()



    return (
        <CardGridEntradaDados>
            <CardGridDivHeaderEntradaDados>
                <GridContainer>
                    <GridItem6xs10>
                        <TipoProjetoVidaSonho
                            TextFieldNumberSelectTipoProjetoVidaSonho={
                                TextFieldNumberSelectDestaque
                            }
                            values={values}
                            item={item}
                            ind={ind}
                            handleChange={handleChange}
                        />
                    </GridItem6xs10>
                    <GridItem5xs1/>
                    <GridItem1>
                        <IconButtonClearEntradaDadosProjetoVidaSonho
                            values={values}
                            setFieldValue={setFieldValue}
                            ind={ind}
                            arrayHelpers={arrayHelpers}
                            simplificado={simplificado}
                        />
                    </GridItem1>
                </GridContainer>
            </CardGridDivHeaderEntradaDados>

            <CardGridDivBodyEntradaDados
                style={{
                    display: 
                        item.tipoProjetoVidaSonho
                            ? "block"
                            : "none"
                }} 
            >
                <GridContainer>
                    <GridItem4xs5>
                        <Valor
                            values={values}
                            item={item}
                            ind={ind}
                            handleChange={handleChange}
                        />
                    </GridItem4xs5>
                    <GridItem4xs5>
                        <ValorAcumulacaoJaRealizado
                            values={values}
                            item={item}
                            ind={ind}
                            handleChange={handleChange}
                        />
                    </GridItem4xs5>
                    <GridItem2>
                        <HelpValorAcumulacaoJaRealizado/>
                    </GridItem2>
                </GridContainer>

                {item.valor !== item.valorAcumulacaoJaRealizado && (
                    <GridContainer>
                        {!item.anoRealizacao && item.familiar !== HARDCODE.idFamiliarFamilia && (
                            <GridItem4xs5>
                                <IdadeRealizacao
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem4xs5>
                        )}
                        {!item.idadeRealizacao && (
                            <GridItem4xs5>
                                <AnoRealizacao
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem4xs5>
                        )}
                </GridContainer>
                )}

                <GridContainer>
                    <GridItem10>
                        <Descricao
                            item={item}
                            ind={ind}
                            handleChange={handleChange}
                        />
                    </GridItem10>
                    <GridItem2>
                        <HelpDescricaoProjetoVidaSonho/>
                    </GridItem2>
                </GridContainer>
                
                {(item.idadeRealizacao || item.anoRealizacao) &&
                item.valor !== item.valorAcumulacaoJaRealizado &&
                linhaTipoLicenca.exibirAcumulacaoAposentadoriaProjetoVidaSonho === 'S' && (
                    <>
                        <CardGridDividerElementos/>

                        <GridContainer>
                            <GridItem3xs10>
                                <TracarMeta
                                    values={values}
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem3xs10>
                            <GridItem2>
                                <HelpTracarMeta/>
                            </GridItem2>
                            {item.tracarMeta && (
                                <>
                                    {!isXsDownScreen && (
                                        <GridItem3/>
                                    )}
                                    <GridItem4xs8>
                                        <TipoPeriodicidadeAporte
                                            item={item}
                                            ind={ind}
                                            handleChange={handleChange}
                                        />
                                    </GridItem4xs8>
                                </>
                            )}
                        </GridContainer>
                    </>
                )}

                {item.tracarMeta && (
                    <>
                        <GridContainer>
                            <GridItem4>
                                <MesAnoInicioAcumulacao
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem4>
                            <GridItem4>
                                <MesAnoFimAcumulacao
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem4>
                            <GridItem4>
                                <MesRealizacao
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem4>
                        </GridContainer>

                        <DadosInvalidosTracarMeta
                            values={values}
                            item={item}
                        />

                        <GridContainer>
                            <GridItem4xs8>
                                <Recorrencia
                                    values={values}
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem4xs8>

                            {item.recorrencia && (
                                <GridItem4>
                                    <AnoLimiteRecorrencia
                                        item={item}
                                        ind={ind}
                                        handleChange={handleChange}
                                    />
                                </GridItem4>
                            )}
                        </GridContainer>

                        <GridContainer>
                            <GridItem4xs8>
                                <ControlarAportes
                                    item={item}
                                    ind={ind}
                                    handleChange={handleChange}
                                />
                            </GridItem4xs8>

                            {item.controlarAportes && (
                                <GridItem4>
                                    <DiaAporte
                                        item={item}
                                        ind={ind}
                                        handleChange={handleChange}
                                    />
                                </GridItem4>
                            )}
                        </GridContainer>
                    </>
                )}
                
                <CardGridDividerElementos/>

                <GridContainer>
                    <GridItem12>
                        <Observacao
                            item={item}
                            ind={ind}
                            handleChange={handleChange}
                        />
                    </GridItem12>
                </GridContainer>
            </CardGridDivBodyEntradaDados>
        </CardGridEntradaDados>
    )
}

export default ProjetoVidaSonhoFormProjetoVidaSonhoItem